import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=63dad99a&scoped=true&"
import script from "./vip.vue?vue&type=script&lang=js&"
export * from "./vip.vue?vue&type=script&lang=js&"
import style0 from "./vip.vue?vue&type=style&index=0&id=63dad99a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dad99a",
  null
  
)

export default component.exports